import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const LandingHeader = ({ hideLoginButton = false }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const isLoggedIn = !!localStorage.getItem("access_token");

  const toggleLanguage = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
  };

  return (
    <header className="landing-header" style={{ display: "block", width: "100%", background: "#ffffff", position: "relative", zIndex: 20 }}>
      <div className="landing-header-inner" dir="ltr">
        <div className="landing-logo">
          <img src="/Landing page assets/Sulhafa_Logo.png" alt="Sulhafa" className="landing-logo-icon" />
          <img src="/Landing page assets/Sulhafa_Logo_Text.png" alt="Sulhafa" className="landing-logo-text" />
        </div>
        <div className="landing-header-actions">
          <button className="landing-lang-btn" onClick={toggleLanguage}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            {i18n.language === "ar" ? "AR" : "ENG"}
          </button>
          {!hideLoginButton && (
            <button
              className="landing-login-btn"
              onClick={() => navigate(isLoggedIn ? "/social/feed" : "/auth/login")}
            >
              {isLoggedIn ? t("header.returnToFeed") : t("header.login")}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;
